import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Sort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { SaveService } from "../../../services/save.service";
import { DefaultValuesService } from "../../../services/defaultvalues.service";
import { CustomDialogService } from "../../../services/customdialog.service";
import { Utils } from "../../../utils/utils";
import { LogsHistoryPopupComponent } from "../logshistorypopup/logshistorypopup.component";

@Component({
    selector: "allowedactionscontrollertype-list",
    templateUrl: './allowedactionscontrollertype-list.component.html',
    styleUrls: ['./allowedactionscontrollertype-list.component.less'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*' })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    standalone: false
})

export class AllowedActionControllerTypeListComponent implements OnInit {
    @Input('list') list: any[] = [];
    @Input('isEditableMethod') isEditable: any
    @Output() onReload = new EventEmitter<any>();

    columnsToDisplay = ['CommandId', 'CommandName', 'Category', 'Description', 'FirstActivationUtc', 'LastChangeUtc', 'actions'];
    dateColumns = ['FirstActivationUtc', 'LastChangeUtc']
    showTable = false;

    @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

    public dataSource = new MatTableDataSource<any>();

    subscriptionTenant: any;
    timeoutFunction: any;
    lastSort: Sort = { active: '', direction: '' };

    constructor(private readonly activatedRoute: ActivatedRoute
        , private readonly router: Router
        , private readonly http: HttpClient
        , private readonly saveService: SaveService
        , public readonly defaults: DefaultValuesService
        , private readonly customDialog: CustomDialogService
        , @Inject('BASE_URL') private readonly baseUrl: string
        , private readonly changeDetectorRefs: ChangeDetectorRef
        , private readonly dialog: MatDialog
    ) {
    }

    openLogsHistory() {
        this.dialog.open(LogsHistoryPopupComponent, {
            width: '80vw',
            maxHeight: '90vh',
            data: { 
                section: 'allowedactionscontrollertype',
                tenantId: this.defaults.tenant,
                controllerTypeId: this.defaults.controllertype.ControllerTypeID
            }
        });
    }

    ngOnChanges() {
        this.dataSource.data = [];
        this.refreshTable();
    }

    ngOnInit() {
        this.getHeader();
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getHeader()
        });
        this.saveService.addListener(this);
    }

    getHeader() {
        this.columnsToDisplay = ['CommandId', 'CommandName', 'Category', 'Description', 'FirstActivationUtc', 'LastChangeUtc', 'actions'];
    }

    getInput(data: any, property: string): any {
        return data[property];
    }

    getDataType(property: string) {
        let result = ''
        if (this.dateColumns.indexOf(property) > -1) result = 'date'
        else result = 'string'
        return result
    }

    applyFilter($event: any) {
        if (this.timeoutFunction) {
            clearTimeout(this.timeoutFunction);
            this.timeoutFunction = null;
        }
        this.timeoutFunction = setTimeout(() => {
            this.dataSource.filter = $event.target.value.trim()
        }, 300)
    }

    changeElement(object: any, type: string, value: boolean) {
        this.http
            .post<any>(
                this.baseUrl + Utils.getRemoteActionAPI() + 'commandconfigcontrollertype' + '/' + object.CommandId + '/' + value, {}
            ).subscribe({
                next: (res) => {
                    // Update the local object directly
                    object.IsSupported = value;
                    // Refresh the table to reflect the change
                    this.dataSource.data = [...this.dataSource.data];
                },
                error: (error) => {
                    this.customDialog.openDisplayInfoDialog({ title: 'Error', message: error.error.message });
                }
            });
    }

    getCommandLabel(data) {
        var transl = data['CommandLabel']
        return transl ? transl : data['CommandLabelRef'];
    }
    sortData(sort: Sort) {
        const data = this.dataSource.data.slice();

        // Cycle: default -> asc -> desc -> default
        if (
            this.lastSort.active === sort.active &&
            this.lastSort.direction === sort.direction
        ) {
            // If user clicks again, reset to default
            sort = { active: '', direction: '' };
        }
        this.lastSort = { ...sort };

        if (!sort.active || sort.direction === '') {
            // Default: enabled first, then disabled
            this.dataSource.data = data.sort((a, b) => {
                const aEnabled = !!a.IsSupported;
                const bEnabled = !!b.IsSupported;
                if (aEnabled !== bEnabled) {
                    return aEnabled ? -1 : 1;
                }
                if (a.CommandId < b.CommandId) return -1;
                if (a.CommandId > b.CommandId) return 1;
                return 0;
            });
            return;
        }

        this.dataSource.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'CommandId':
                    return this.compare(a.CommandId, b.CommandId, isAsc);
                case 'CommandName':
                    return this.compare(
                        this.getCommandLabel(a)?.toUpperCase() || '',
                        this.getCommandLabel(b)?.toUpperCase() || '',
                        isAsc
                    );
                case 'Category':
                    return this.compare(
                        (a['Category'] ?? '').toUpperCase(),
                        (b['Category'] ?? '').toUpperCase(),
                        isAsc
                    );
                default:
                    return 0;
            }
        });
    }
    refreshTable() {
        this.showTable = false;
        setTimeout(() => {
            this.dataSource.data = [...this.list];
            this.showTable = true;
        }, 0);
    }

    compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
}